import { useTranslation } from "react-i18next";
import { LANGUAGES, currentLanguage, type Language } from "@/i18n";
import { changeLanguage } from "@/features/auth/language";
import { Segmented } from "@/components/ui/segmented";

/**
 * Tilni almashtirish (segmentli): UI darhol, keyin profilga saqlanadi (features/auth/language.ts).
 * persist={false} -- kirishdan oldingi sahifalar: tanlov eslab qolinadi va kirgach profilga yoziladi.
 * Ilova ichida profil menyusida turadi (yuqori panelda emas: redesign v2).
 */
export function LanguageSwitcher({ persist = true, className, fullWidth }: { persist?: boolean; className?: string; fullWidth?: boolean }) {
  const { t } = useTranslation(); // til o'zgarganda qayta chiziladi
  const current = currentLanguage();
  return (
    <Segmented<Language>
      ariaLabel={t("language")}
      size="sm"
      className={className}
      fullWidth={fullWidth}
      value={current}
      onChange={(code) => void changeLanguage(code, { persist })}
      options={LANGUAGES.map((l) => ({ value: l.code, label: <span lang={l.code}>{l.short}</span>, title: l.label }))}
    />
  );
}
